import {Record} from "./Record";

export class Comment extends Record {
    text:string = "";
    user_display_name:string = "";
    user_id:string | null = null;
}
